import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import AbstractFilter from '../AbstractFilter';
import { FILTER_EVENT } from '../FilterEvent';

export default class EnhancedRangeFilter extends AbstractFilter {
  constructor(...args) {
    super(...args);
    this._values = [];
    this._autoSubmit = this._dom.container.hasAttribute('data-auto-submit') ?? false;
    this._getDom();
    this._getConfig();
    this._getDefaults();
    this._initRangeSlider();
  }

  _getDom() {
    this._dom.holder = this._dom.container.parentElement.querySelector('.js-widget-holder');
    this._dom.min_input = this._dom.container.querySelector('.js-range-min');
    this._dom.max_input = this._dom.container.querySelector('.js-range-max');
  }

  _getConfig() {
    this._config = {
      min: parseInt(this._dom.container.getAttribute('data-min')),
      max: parseInt(this._dom.container.getAttribute('data-max')),
      step: parseInt(this._dom.container.getAttribute('data-step')),
      range: JSON.parse(this._dom.container.getAttribute('data-range')),
      unit: { money: ' €', hour: ' h', null: '' }[this._dom.container.getAttribute('data-unit')],
      default: { min: 0, max: 0 },
    };
  }

  _getDefaults() {
    const min = parseInt(this._dom.min_input.value);
    this._config.default.min = isNaN(min) ? this._config.min : min;
    const max = parseInt(this._dom.max_input.value);
    this._config.default.max = isNaN(max) ? this._config.max : max;
    this._values = [{
      min: isNaN(min) ? this._config.min : min,
      max: isNaN(max) ? this._config.max : max,
    }];
  }

  _initRangeSlider() {
    let range = {
      min: [this._config.min],
      max: [this._config.max],
    };
    if (this._config['range'] !== null
      && typeof this._config['range'] === 'object'
      && Array.isArray(this._config['range']['min'])
      && Array.isArray(this._config['range']['max'])) {
      range = this._config.range;
    }
    const obj = {
      tooltips: [true, true],
      start: [this._config.default.min, this._config.default.max],
      step: this._config.step,
      connect: true,
      range: range,
      format: wNumb({
        decimals: 0,
        thousand: ' ',
        suffix: this._config.unit,
      }),
    };
    noUiSlider.create(this._dom.holder, obj);
    this._dom.holder.noUiSlider.on('change', (values) => {
      const response = [];
      for (let i = 0; i < values.length; i++) {
        const value = values[i].replace(/[€h ]/g, '');
        response.push(value);
      }
      this._updateValues(response);
    });
  }

  _updateValues(values) {
    for (let i = 0, j = values.length; i < j; i++) {
      values[i] = parseInt(values[i]);
    }
    const min = values[0];
    const max = values[1];
    this._values = [{ min, max }];
    this._dom.min_input.value = min;
    this._dom.max_input.value = max;
    this.emit(FILTER_EVENT.CHANGED, { interactive: true });
    if (this._autoSubmit === true) {
      this.emit(FILTER_EVENT.AUTO_SUBMIT);
    }
  }

  removeAllChoices() {
    this._dom.holder.noUiSlider.set([this._config.min, this._config.max]);
    this._dom.min_input.value = this._config.min;
    this._dom.max_input.value = this._config.max;
    this._values = [{ min: this._config.min, max: this._config.max }];
    this.emit(FILTER_EVENT.CHANGED, { interactive: false });
  }

  isMultiple() {
    return false;
  }
}
